import { render, staticRenderFns } from "./ck-editor-input.vue?vue&type=template&id=4e0f6649"
import script from "./ck-editor-input.vue?vue&type=script&lang=js"
export * from "./ck-editor-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports